<template>
  <label class="cursor-pointer inline-block">
    <span class="flex items-center">
      <input
        :id="id"
        :name="name"
        :checked="isActive"
        class="custom-switch-input"
        type="checkbox"
        role="switch"
        :aria-checked="isActive"
        @click="toggle"
        @keydown.enter="toggle"
      >
      <template v-if="$slots.label">
        <span class="pl-4">
          <slot name="label" />
        </span>
      </template>
    </span>
  </label>
</template>

<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  modelValue: {
    type: [Boolean, String, Number, Array],
    default: null
  },
  value: {
    type: [String, Number],
    default: ''
  },
  trueValue: {
    type: [Boolean, String, Number],
    default: true
  },
  falseValue: {
    type: [Boolean, String, Number],
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits<{(e: 'update:modelValue', value: string): void}>()

const isActive = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.includes(props.value)
  } else {
    return !!props.modelValue
  }
})

const toggle = () => {
  if (Array.isArray(props.modelValue)) {
    if (props.modelValue.includes(props.value)) {
      emit('update:modelValue', props.modelValue.filter(x => x !== props.value))
    } else {
      emit('update:modelValue', [...props.modelValue, props.value])
    }
  } else {
    emit('update:modelValue', !isActive.value ? props.trueValue : props.falseValue)
  }
}
</script>
<style>
@reference "~/assets/css/main.css";
input[type=checkbox].custom-switch-input{
  @apply bg-neutral-600 border-2 border-neutral-600 text-white rounded-full focus:outline-hidden focus:border-neutral-600 focus:ring-2 focus:ring-petrol-500 p-0;
  width: 2.5em;
  height: 1.5em;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100% !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  print-color-adjust: exact;
  transition: background-position .15s ease-in-out;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23f0f0f0'/%3e%3c/svg%3e");
  &:checked{
    @apply bg-petrol-50 border-petrol-500 text-white;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23179396'/%3e%3c/svg%3e");
    background-position: right center;
    &:hover, &:active, &:focus{
      @apply bg-petrol-100 border-petrol-500 text-white;
    }
  }
}
</style>
